module.exports = __webpack_public_path__ + "static/luacheia-video-en-6d9c9df619d42884d1722e55790bb81e.mp4";